import type { BaseKeyFunction } from "../../../../../../lib/types/baseKeyFunction";
import type { CommunitiesStatsTimeGraphType } from "./useRequestCommunitiesStatsTimeGraph";

export type KeyCommunitiesStatsTimeGraphProps = {
  endDate?: Date;
  id: number;
  startDate?: Date;
  type: CommunitiesStatsTimeGraphType;
};

export const keyCommunitiesStatsTimeGraph: BaseKeyFunction<
  KeyCommunitiesStatsTimeGraphProps
> = ({ endDate, id, startDate, type }) => [
  "communities-stats-time-graph",
  id?.toString(),
  type,
  startDate?.toString(),
  endDate?.toString(),
];
